<template>
    <div>
        <div v-show="value">
            <b>{{ message }}</b>
            <b-progress
                striped
                animated
                :value="value"
                height="3px"
            />
        </div>
    </div>
</template>
<script>
export default {
    name: 'ProgressCustom',

    data() {
        return {
            value: 0,
            max: 100,
            message: ''
        }
    },

    methods: {
        progress(value, message) {
            this.value = value;
            this.message = message;
        },
    }

}
</script>
<style></style>